// https://material-ui.com/ru/api/checkbox/

import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import { Checkbox as MaterialCheckbox, FormControlLabel } from '@material-ui/core';

import { 
  CheckboxLabelPlacementStart, CheckboxLabelPlacementEnd
} from "./constants.js";

const styles = theme => ({
  root: {
    "& .MuiFormControlLabel-label": {
      fontSize: "14px",
      ['@media (max-width: 768px)']: {
        fontSize: "13px",
        lineHeight: "16px",
        fontWeight: theme.typography.fontWeightLight
      },
    }
  }
});

/**
 * Callback for inputs
 * @callback Checkbox~onChange
 * @param {boolean} value input's new value
 */

/**
 * Simple checkbox
 * @name Checkbox
 * @param {object} props React component properties
 * @param {boolean} [props.checked] Field's value
 * @param {HTMLElement} [props.displayName] Field's display name
 * @param {string} [props.placement = "end"] Placement of display name, before or after checkbox. Available values:
 *  - "start" 
 *  - "end" 
 * 
 * NOTE: for providing placement, please, import necessary type as constant from file "components/base/inputs/constants.js.jsx"
 * @param {string} [props.className] CSS-class of button
 * @param {Checkbox~onChange} [props.onChange] On change handler
 * @example
 * return (
 *   <Checkbox className={ "awesome-class" } 
 *              onChange = { (value) => {
*                 // Some actions
 *              } } 
 *              displayName = { <div><b>Check me!</b></div>}
 *              checked = { false } />
 * )
*/

class Checkbox extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      
    }

    this.onChange = this.onChange.bind(this);
  }

  static getDerivedStateFromProps(props, state) {
    let checked;

    let propsChecked   = props.checked;
    let defaultChecked = state.defaultChecked;
    let stateChecked   = state.checked;
    
    if(defaultChecked !== propsChecked) {
      defaultChecked = propsChecked;
      checked = propsChecked;
    }
    else {
      checked = stateChecked;
    }

    return {
      checked: checked,
      defaultChecked: defaultChecked
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return this.state.checked !== nextState.checked;
  }

  onChange(event) {
    const { onChange } = this.props;
    let checked = event.target.checked;
    this.setState({
      checked: checked
    });

    if(onChange) {
      onChange(checked);
    }
  }

  render() {
    const { classes, className, checkboxClass } = this.props;

    const { id, name, displayName, placement } = this.props;

    const { checked } = this.state;

    return <FormControlLabel className = { clsx(classes.root, className) }
                             control = { 
                              <MaterialCheckbox onChange = { this.onChange }
                                                checked = { checked } 
                                                className = { checkboxClass }
                                                id = { id }
                                                name = { name } /> 
                             }
                             label = { displayName }
                             value = { name }
                             labelPlacement = { placement } />
  }

  helperText() {
    return "";
  }
}

Checkbox.propTypes = {
  checked: PropTypes.bool.isRequired,
  placement: PropTypes.oneOf([CheckboxLabelPlacementStart, CheckboxLabelPlacementEnd]),
  displayName: PropTypes.node
};

Checkbox.defaultProps = {
  checked: false,
  placement: CheckboxLabelPlacementEnd
}

export default withStyles(styles)(Checkbox);
